module.exports = __webpack_public_path__ + "static/img/solution_b_pro.29512e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution_b_pro.png
// module id = YFy4
// module chunks = 1